import React, { useEffect, useState, useCallback } from 'react';

const OnlineStatus = ({ activeTime }) => {
    const [timeAgo, setTimeAgo] = useState('');

    const parseServerTime = useCallback((timestamp) => {
        if (!timestamp) return null;
        // Server stores time in UTC, append 'Z' if not present to treat as UTC
        const utcTimestamp = timestamp.includes('Z') || timestamp.includes('+')
            ? timestamp
            : timestamp.replace(' ', 'T') + 'Z';
        return new Date(utcTimestamp);
    }, []);

    const formatTimeAgo = useCallback((timestamp) => {
        if (!timestamp) return '';

        const now = new Date();
        const activeDate = parseServerTime(timestamp);
        if (!activeDate) return '';

        const diffInSeconds = Math.floor((now - activeDate) / 1000);

        if (diffInSeconds < 60) {
            return 'just now';
        } else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        } else if (diffInSeconds < 604800) {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days} day${days > 1 ? 's' : ''} ago`;
        } else {
            return activeDate.toLocaleDateString([], {
                month: 'short',
                day: 'numeric'
            });
        }
    }, [parseServerTime]);

    const checkOnlineStatus = useCallback(() => {
        if (!activeTime) {
            setTimeAgo('');
            return;
        }

        const activeDate = parseServerTime(activeTime);
        if (!activeDate) {
            setTimeAgo('');
            return;
        }

        setTimeAgo(formatTimeAgo(activeTime));
    }, [activeTime, formatTimeAgo, parseServerTime]);

    useEffect(() => {
        checkOnlineStatus();
        const interval = setInterval(checkOnlineStatus, 60000);
        return () => clearInterval(interval);
    }, [checkOnlineStatus]);

    if (!timeAgo) {
        return <span className="offline-status">Offline</span>;
    }

    return (
        <span className="offline-status">
            Active {timeAgo}
        </span>
    );
};

export default OnlineStatus;
